import React, { FormEventHandler } from 'react';
import cn from 'classnames';

import ActionsCard from '@/components/common/ActionsCard/ActionsCard';
import styles from './option-button.module.scss';

interface IOptionButtonProps {
  onClick: FormEventHandler<HTMLButtonElement>;
  Icon: JSX.Element;
  children: string | JSX.Element;
  className?: string;
}

export default function OptionButton({ onClick, Icon, children, className }: IOptionButtonProps) {
  return (
    <ActionsCard>
      <div className={styles['option-button']}>
        <div>{children}</div>
        <button
          className={cn(styles.button, className)}
          onClick={onClick}
        >
          {Icon}
        </button>
      </div>
    </ActionsCard>
  );
}

